const LINES_WORD_RANGE_PATTERN = /\(?\blines?\s+(\d+)\s*[-–—]\s*(\d+)\)?/i;
const COLON_RANGE_PATTERN = /:(\d+)\s*[-–—]\s*(\d+)\b/;

export const CODE_LINE_OMIT_CLASS = 'md-code-line-omit';
export const CODE_BLOCK_LINE_NUMBERS_CLASS = 'md-code-show-line-numbers';

export function parseCodeFenceLineRangeStart(text: string): number | undefined {
  const match =
    LINES_WORD_RANGE_PATTERN.exec(text) ?? COLON_RANGE_PATTERN.exec(text);

  if (!match) {
    return undefined;
  }

  const start = Number(match[1]);

  if (!Number.isFinite(start) || start < 1) {
    return undefined;
  }

  return start;
}

function collectPrecedingText({ pre }: { pre: Element }): string {
  const parts: string[] = [];
  let sibling = pre.previousElementSibling;

  for (let index = 0; index < 3 && sibling; index += 1) {
    const text = sibling.textContent?.trim();

    if (text) {
      parts.push(text);
    }

    sibling = sibling.previousElementSibling;
  }

  return parts.join('\n');
}

function isLeadingMetaLine(text: string): boolean {
  const trimmed = text.trim();

  if (!trimmed) {
    return true;
  }

  return parseCodeFenceLineRangeStart(trimmed) !== undefined;
}

function parseLeadingInFenceRangeStart({
  code,
}: {
  code: Element;
}): number | undefined {
  const lines = code.querySelectorAll('.code-line');

  for (const line of lines) {
    const text = line.textContent ?? '';

    if (!isLeadingMetaLine(text)) {
      break;
    }

    const trimmed = text.trim();

    if (!trimmed) {
      continue;
    }

    const start = parseCodeFenceLineRangeStart(trimmed);

    if (start !== undefined) {
      return start;
    }
  }

  return undefined;
}

function clearOmitClasses({ code }: { code: Element }): void {
  code
    .querySelectorAll(`.code-line.${CODE_LINE_OMIT_CLASS}`)
    .forEach((line) => {
      line.classList.remove(CODE_LINE_OMIT_CLASS);
    });
}

function omitLeadingInFenceMetaLines({ code }: { code: Element }): void {
  const lines = code.querySelectorAll('.code-line');

  for (const line of lines) {
    const text = line.textContent ?? '';

    if (!isLeadingMetaLine(text)) {
      break;
    }

    line.classList.add(CODE_LINE_OMIT_CLASS);
  }
}

export function applyCodeFenceLineRangeStarts({
  root,
}: {
  root: ParentNode;
}): void {
  root.querySelectorAll('pre').forEach((pre) => {
    const code = pre.querySelector('code');

    if (!(code instanceof HTMLElement)) {
      return;
    }

    clearOmitClasses({ code });

    const precedingStart = parseCodeFenceLineRangeStart(
      collectPrecedingText({ pre }),
    );
    const leadingStart = parseLeadingInFenceRangeStart({ code });
    const start = precedingStart ?? leadingStart ?? 1;

    if (leadingStart !== undefined) {
      omitLeadingInFenceMetaLines({ code });
    }

    code.classList.add(CODE_BLOCK_LINE_NUMBERS_CLASS);
    code.style.counterReset = `md-code-line ${start - 1}`;
  });
}
